import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=542645f8&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=542645f8&prod&lang=scss&scoped=true"
import style1 from "./PaymentInfo.vue?vue&type=style&index=1&id=542645f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542645f8",
  null
  
)

export default component.exports